export const allFoldersInArchive = "RvS5N";
export const allFoldersString = "h12Gcb";
export const currentMailboxString = "UD1sO";
export const allMailboxesString = "CbKh1d";
export default {allFoldersInArchive,allFoldersString,currentMailboxString,allMailboxesString};